import type { JSX } from '@builder.io/qwik';
import { useContext, component$ } from '@builder.io/qwik';
import { ArticleContext } from '~/contexts/ArticleContext';
import Ad from '~/components/Shared/Ads/Ad';
import { AppDataContext } from '~/contexts/AppDataContext';

type AdType = {
  id: string;
  location:
    | 'top'
    | 'belowTopSection'
    | 'belowSecondSection'
    | 'sidebar1'
    | 'sidebar2'
    | 'oneOnOne'
    | null
    | undefined;
};

/**
 * Ad component for ads that exist INSIDE the Article Builder
 */
export default component$<AdType>(({ id, location }): JSX.Element => {
  // This Ad component must use ArticleContext so that we have access to finiteScroll
  const article = useContext(ArticleContext);
  const appData = useContext(AppDataContext);

  const includeInFinitescroll = ['sidebar1', 'sidebar2'];

  if (!article) return <></>;

  // Don't show ads if it's a finiteScroll article (ads only allowed on the first article)
  if (
    article.finiteScrollNumber &&
    article.finiteScrollNumber > 0 &&
    (!location || !includeInFinitescroll.includes(location))
  )
    return <></>;

  const theId =
    article.finiteScrollNumber && article.finiteScrollNumber > 0
      ? `${id}-${article.finiteScrollNumber}`
      : id;

  // Check if ads are disabled (use appData because finite scroll articles don't have the commercialTags)
  if (
    appData.article?.metadata?.commercialTags &&
    appData.article.metadata.commercialTags.includes('no-ads')
  )
    return <></>;

  return <Ad id={theId} cssClasses={id} location={location} />;
});
